import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizenVerifyOptNumber} from './citizen-verify-opt-number.model';
import * as CitizenVerifyOptNumberActions from './citizen-verify-opt-number.actions';

export const citizenVerifyOptNumbersFeatureKey = 'citizenVerifyOptNumbers';

export interface State extends EntityState<CitizenVerifyOptNumber> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizenVerifyOptNumber> = createEntityAdapter<CitizenVerifyOptNumber>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizenVerifyOptNumberActions.addCitizenVerifyOptNumber,
    (state, action) => adapter.addOne(action.citizenVerifyOptNumber, state)
  ),
  on(CitizenVerifyOptNumberActions.upsertCitizenVerifyOptNumber,
    (state, action) => adapter.upsertOne(action.citizenVerifyOptNumber, state)
  ),
  on(CitizenVerifyOptNumberActions.addCitizenVerifyOptNumbers,
    (state, action) => adapter.addMany(action.citizenVerifyOptNumbers, state)
  ),
  on(CitizenVerifyOptNumberActions.upsertCitizenVerifyOptNumbers,
    (state, action) => adapter.upsertMany(action.citizenVerifyOptNumbers, state)
  ),
  on(CitizenVerifyOptNumberActions.updateCitizenVerifyOptNumber,
    (state, action) => adapter.updateOne(action.citizenVerifyOptNumber, state)
  ),
  on(CitizenVerifyOptNumberActions.updateCitizenVerifyOptNumbers,
    (state, action) => adapter.updateMany(action.citizenVerifyOptNumbers, state)
  ),
  on(CitizenVerifyOptNumberActions.deleteCitizenVerifyOptNumber,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizenVerifyOptNumberActions.deleteCitizenVerifyOptNumbers,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizenVerifyOptNumberActions.loadCitizenVerifyOptNumbers,
    (state, action) => adapter.setAll(action.citizenVerifyOptNumbers, state)
  ),
  on(CitizenVerifyOptNumberActions.clearCitizenVerifyOptNumbers,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
